'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconWindowCode, iconWindowCodeTag } from '@ni/nimble-components/dist/esm/icons/window-code';
import { wrap } from '../../utilities/react-wrapper';

export type { IconWindowCode };
export { iconWindowCodeTag };
export const NimbleIconWindowCode = wrap(IconWindowCode);